import { render, staticRenderFns } from "./Editor1.vue?vue&type=template&id=02fa71ec&scoped=true"
import script from "./Editor1.vue?vue&type=script&lang=js"
export * from "./Editor1.vue?vue&type=script&lang=js"
import style0 from "./Editor1.vue?vue&type=style&index=0&id=02fa71ec&prod&lang=scss&scoped=true"
import style1 from "./Editor1.vue?vue&type=style&index=1&id=02fa71ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa71ec",
  null
  
)

export default component.exports